import './geo.less';
import { contactGoal } from 'globalState/goals/';

$(function () {
    $('.city').fancybox();

    $('.region-popup-link').on('click', function () {
        $.fancybox.open({
            href: $(this).data('href'),
            type: 'ajax',
            width: 'auto',
        });
    });

    $(document).on('click', '.confirm-button', function () {
        if ($(this).hasClass('yes')) {
            $.ajax({
                url: $('.region-selection-confirmation').data(
                    'location-set-selected-url'
                ),
            });
            $('.region-selection-confirmation-wrapper').remove();
        }
    });
});

const whatsappCall = document.querySelectorAll(
    '.header-left__whatsapp, .footer__whatsapp, .header-icon__whatsapp'
);

if (whatsappCall) {
    whatsappCall.forEach((element) => {
        element.addEventListener('click', () => {
            contactGoal.headerWhatsappCall();
        });
    });
}
